import { createStyles, IconButton, makeStyles, Menu, MenuItem, Theme } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import React, { useState } from 'react';
import { SectionTabMenuProps } from './SectionTabType';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(-1),
    },
  }),
);

export const SectionTabMenu = (props: SectionTabMenuProps): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const classes = useStyles();
  return (
    <>
      <IconButton
        aria-label="tab kebab menu button"
        className={classes.root}
        data-testid="kebab-menu-button"
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        size="small"
      >
        <MoreVert />
      </IconButton>
      <Menu
        data-testid="tab-menu"
        elevation={2}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={(event: React.ChangeEvent) => {
          event.stopPropagation();
          setAnchorEl(null);
        }}
      >
        <MenuItem
          disabled
          data-testid="tab-menu-remove"
          onClick={(event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
            event.stopPropagation();
          }}
        >
          {props.menuItemLabel}
        </MenuItem>
        <MenuItem
          disabled
          data-testid="tab-menu-add"
          onClick={(event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
            event.stopPropagation();
          }}
        >
          {props.menuItemLabel2}
        </MenuItem>
      </Menu>
    </>
  );
};

export default SectionTabMenu;
